import { styled } from 'styled-components';

export const SliderContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  padding: ${({ theme }) => theme.space.component.x.l};
  border-radius: ${({ theme }) => theme.radiuses.xxl};
`;

// Note: sliderStyles is used as a JS object (not in styled-components),
// so theme values need to be accessed at runtime in the component
export const getSliderStyles = (theme: any) => ({
  track: {
    borderColor: theme.colors.primary.normal,
    backgroundColor: theme.colors.primary.normal,
    height: 3,
  },
  handle: {
    color: theme.palette.white,
    borderColor: theme.palette.white,
    boxShadow: theme.shadows.default,
    opacity: 1,
    height: '1.25rem',
    width: '1.25rem',
    marginTop: '-0.5rem',
  },
  rail: {
    height: 3,
    backgroundColor: theme.palette.grey300,
  },
});
